import type { GTMEventName } from './types';

export type GTMEventValues = Record<string, unknown>;

/**
 * Pushes an event to Google Tag Manager's dataLayer
 * @param name - The name of the event
 * @param values - Optional object containing additional event data
 * @param isEcommerce - Optional boolean
 */
export const pushGTMEvent = (
  name: GTMEventName,
  values: GTMEventValues = {},
  isEcommerce: boolean = false
): void => {
  const eventData: GTMEventValues = values
    ? { event: name, [isEcommerce ? 'ecommerce' : 'eventInfo']: values }
    : { event: name };

  publishGTMEvent(eventData);
};

export type _GTMEventValues = Record<string, string | GTMEventValues>;

export const _pushGTMEvent = (values: _GTMEventValues): void => {
  publishGTMEvent(values);
};

const publishGTMEvent = (values: GTMEventValues) => {
  if (import.meta.env.VITE_ENABLE_GTM === 'false') {
    return;
  }

  if (import.meta.env.DEV && import.meta.env.VITE_LOG_GTM_EVENTS === 'true') {
    console.log('[GTM] Pushing event: ', values);
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(values);
};
